module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"review_policy":"评价运营方式"}}')
  delete Component.options._Ctor
}
